import React from 'react'

import { Modal } from '../../../components/Modal'
import Button from '../../../components/Button'
import { ModalWrapper } from '../../../screens/cpf/components/CPFModal/styles'
import { Video } from './Video'
import { Photo } from './Photo'

export const StepTwo = ({ type = 'photo', show, onDismiss, next, name }) => {
  const obj = {
    video: <Video name={name} />,
    photo: <Photo />,
  }

  return (
    <Modal show={show} title="2° passo" onDismiss={onDismiss}>
      {obj[type] || <></>}
      <ModalWrapper>
        <Button text="Avançar" width="220px" mobileWidth="220px" onClick={next} />
      </ModalWrapper>
    </Modal>
  )
}
